import React from 'react'
import Placeholder from '../misc/placeholder'
import { getContactPhotoURL } from '../../helpers/api'
import ModalContact from '../misc/modal-contact'
import { getContactList } from '../../helpers/api'

const Contacts = props => {
    const { ContributorID, signalReady } = props

    const [_contacts, setContacts] = React.useState(null)

    React.useEffect(() => {
        getContactList(ContributorID)
            .then(data => {
                setContacts(data)
                signalReady && signalReady('contacts')
            })
    }, [])

    const [modal, setModal] = React.useState(null)

    return _contacts ? (
        <React.Fragment>
            <a className="anchor" href="/" id="section-contacts">{' '}</a>
            <section className="section">
                <h3 className="section-header">Contacts ({_contacts.length})</h3>
                <div className="table-responsive">
                    {_contacts.length > 0 ? (
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Name</th>
                                    <th>Title</th>
                                    <th className="d-none d-sm-block print-none">&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                {_contacts && _contacts.map((d, idx) => (
                                    <tr className="cursor-pointer" key={idx} onClick={() => setModal({ data: d })}>
                                        <td style={{ width: '48px' }}>
                                            <img style={{ borderRadius: '48px' }} width="48" height="48" alt={d.Name} src={getContactPhotoURL(d.contact_id)} />
                                        </td>
                                        <td><strong>{''.concat(d.Salutation, ' ', d.Name).trim()}</strong></td>
                                        <td>{d.Title}</td>
                                        <td className="text-right d-none d-sm-block print-none">
                                            <button
                                                onClick={() => setModal({ data: d })}
                                                type="button"
                                                className="btn btn-sm btn-secondary"><i className="fas fa-address-card"></i> Details</button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (<p>No contacts registered for this contributor.</p>)}
                </div>
            </section>
            <ModalContact modal={modal} closeModal={() => setModal(null)} />
        </React.Fragment>
    ) : <Placeholder />
}

export default Contacts